import { render } from "./home.vue?vue&type=template&id=190996c1&scoped=true"
import script from "./home.ts?vue&type=script&lang=ts"
export * from "./home.ts?vue&type=script&lang=ts"

import "./home.css?vue&type=style&index=0&id=190996c1&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-190996c1"

export default script